import { useContext, useState } from 'react';
import './EmailLinkSigninPage.scss';
import { Alert, Button, TextField } from '@mui/material';
import { AuthContext } from '../../context';
import { Page } from '../../components';

export const EmailLinkSigninPage = () => {
    const { loginWithEmail, authLoading, authError, authMessage } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [error, setError] = useState(false);

    const handleClick = async () => {
        const trimmedEmail = email.trim();
        const hasEmail = !!trimmedEmail;

        setError(!hasEmail);

        if (hasEmail) {
            await loginWithEmail(trimmedEmail);
        }
    };

    return (
        <Page className="EmailLinkSigninPage">
            <h2>Save your lists</h2>
            <p className="subtitle">Sign in to keep your favorite spells saved and synced.</p>

            {authError && <Alert severity="error">{authError}</Alert>}
            {!authError && authMessage && <Alert severity="success">{authMessage}</Alert>}

            <TextField 
                id="email"
                label="Email Address"
                type="email"
                variant='standard'
                error={error || !!authError}
                helperText={error ? 'Please enter a valid email address.' : ' '}
                value={email}
                onChange={e => {
                    setEmail(e.target.value);
                    if (error) {
                        setError(false);
                    }
                }}
            />
            <Button variant='contained' onClick={handleClick} disabled={authLoading}>
                {authLoading ? 'Sending link...' : 'Send Sign-In Link'}
            </Button>
        </Page>
    );
};